/**
 * Created by lihanying on 2017/7/6.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import Users from './component/users'
import { Spin } from 'antd'

class ClubUsers extends React.Component {
  static defaultProps = {
    accountList: [],
    roleList: [],
  }
  state = {
    loading: true,
  }

  componentDidMount() {
    this.props.fetchAccountList().then((res) => {
      this.setState({ loading: false })
    })
  }

  render() {
    const { accountList, roleList, regionList } = this.props
    return (
      <div>
        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <Users
            list={accountList}
            roleList={roleList}
            regionList={regionList}
            fetchEditAccount={this.props.fetchEditAccount}
            fetchDelAccount={this.props.fetchDelAccount}
            fetchAddAccount={this.props.fetchAddAccount}
            fetchRoleList={this.props.fetchRoleList}
            fetchRegionList={this.props.fetchRegionList}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    accountList: state.getClubUsers.accountList,
    roleList: state.getClubUsers.roleList,
    regionList: state.getClubUsers.regionList,
  }
}
export default withRouter(connect(mapStateToProps, actions)(ClubUsers))



// WEBPACK FOOTER //
// ./src/containers/ClubUsers/index.js